export const CARS_STATE = 'CARS';

export const CAR_NUMBER_ICON_WIDTH = 600;
export const CAR_NUMBER_ICON_HEIGHT = 48;
